
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.en.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.en.md?type=demo')
};